import { useState } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../util";

export default function ActionBtnsWithOrdering({
  saveOrdering,
  orderingDisabled,
  rows,
  fetchData,
  bulkDeleteApi,
  subject,
  disabled,
}) {
  const capitalizedSubject = subject.charAt(0).toUpperCase() + subject.slice(1);
  const [actionType, setActionType] = useState("");

  const handleSelectChange = (e) => {
    setActionType(e.target.value);
  };

  const handleBulkAction = async () => {
    switch (actionType) {
      case "DELETE":
        try {
          let ids = [];
          let deleteCount = 0;
          for (var i = 0; i < rows.length; i++) {
            if (rows[i].isSelected) {
              ids.push(rows[i].original.id);
              deleteCount++;
            }
          }
          const decision = await modal.fire({
            title: `Delete ${capitalizedSubject}`,
            text: `Are you sure to delete ${deleteCount} ${subject}(s)?`,
            showCancelButton: true,
            confirmButtonText: `Delete`,
          });
          if (deleteCount > 0 && decision.isConfirmed) {
            let result = await bulkDeleteApi(ids);
            if (!Array.isArray(result)) result = [result];
            if (result.every(res => res.data.code === 0)) {
              fetchData();
              toast.dark(`${deleteCount} ${capitalizedSubject}(s) deleted.`)
            }
          }
        } catch (err) {
          console.log(err);
        }
        return;
      default:
        return;
    }
  };

  return (
    <>
      <Grid container item xs={6}>
        <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel id="demo-simple-select-outlined-label">
            Bulk Actions
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            value={actionType}
            onChange={handleSelectChange}
            label="Bulk Actions"
            disabled={disabled}
          >
            <MenuItem value={"NONE"}>
              <em>None</em>
            </MenuItem>
            <MenuItem value={"DELETE"}>Delete</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid container item xs={2}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleBulkAction}
          disabled={disabled}
        >
          Apply
        </Button>
      </Grid>
      <Grid container item xs={4}>
        <Button
          variant="contained"
          color="primary"
          onClick={saveOrdering}
          disabled={orderingDisabled || disabled}
        >
          Save Changes
        </Button>
      </Grid>
    </>
  );
}
